import { Col, Row, Toast, Container } from '@microfrontends/react-components'
import { useState } from 'react'
import RecommendJobsSlide from '../../../components/NumerologyV2/RecommendJobsSlide'
import Title from '../../../components/NumerologyV2/Title'
import { Box, RecommendJobsCss } from '../Numerology.css'

interface IProps {
	title?: string
	utm: {
		utm_source: string
		utm_medium: string
		utm_campaign: string
	}
	containerWidth?: string
}

export default function RecommendJobs({
	title,
	utm,
	containerWidth = 'md'
}: IProps) {
	const [isNoJobs, setIsNoJobs] = useState(false)

	if (isNoJobs) {
		return <></>
	}

	return (
		<RecommendJobsCss>
			<Col>
				<Container>
					<Row>
						<Col>
							<Box className='center'>
								<Title
									title={title}
									marker='triangle'
									backgound='oval'
									backgroundColor='#fff'
								/>
							</Box>
						</Col>
						<Col>
							<RecommendJobsSlide
								utm={utm}
								handleNoJobs={() => {
									setIsNoJobs(true)
								}}
							/>
						</Col>
					</Row>
				</Container>
			</Col>
			<Toast />
		</RecommendJobsCss>
	)
}
